import Vue from 'vue';

class NotificationService {
  success(text, title = 'Success!') {
    return Vue.notify({
      type: 'success',
      title,
      text,
    });
  }

  error(text, title = 'Error!', duration = 5000) {
    return Vue.notify({
      type: 'error',
      title,
      text,
      duration,
    });
  }

  stickyError(text, title) {
    return this.error(text, title, -1);
  }
}

export default new NotificationService();
